import { connect } from 'react-redux';
import { joinWaitlist, checkWaitlist, requestHotelSearch, requestHotelClaim } from '../modules/hotels';

import AddHotel from '../components/AddHotel';

const mapDispatchToProps = {
  requestHotelSearch,
  requestHotelClaim,
  joinWaitlist,
  checkWaitlist,
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.hotels.search.isFetching,
  needFetch: state.hotels.search.needFetch,
  hasError: state.hotels.search.hasError,
  hotels: state.hotels.search.hotels,
  onWaitlist: state.hotels.waitlist.onWaitlist,
  waitlistisFetching: state.hotels.waitlist.needFetch || state.hotels.waitlist.isFetching,
  perms: state.auth.perms,
  id: ownProps.params.id,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddHotel);



// WEBPACK FOOTER //
// src/routes/hotels/containers/AddHotelContainer.js